import cn from "classnames";
import { useState } from "react";
import { Avatar } from "src/shared/ui/Avatar";
import LazyImages from "src/components/lazyImages";
import defaultPlaceholder from "src/assets/images/defaultPlaceholder.png";
import endpoints from "src/core/endpoints";
import { useStyles } from "./styles";
import { UserStarsBorder } from "../../../../../components/controls/app-bar/components/animateStar/UserStarsBorder";

interface IPlayerProps {
    avatarUrl: string;
    nickname: string;
    isMobile?: boolean;
    className?: string;
    id: string;
    stars?: number;
}

export const Player = ({
    avatarUrl,
    nickname,
    isMobile,
    className,
    id,
    stars = 0
}: IPlayerProps) => {
    const classes = useStyles();
    const [isLoaded, setLoaded] = useState<boolean>(false);

    if (isMobile) {
        return (
            <div className={cn(classes.playerWrapper, className)}>
                <div className={classes.avatarContainer}>
                    <UserStarsBorder starsCount={stars} className={classes.starsOverlay} starSize={7}/>
                    <LazyImages
                        wrapperClassName={cn(
                            classes.playerAvatar,
                            { isLoaded: !isLoaded },
                            className
                        )}
                        placeholderImg={defaultPlaceholder}
                        src={endpoints.avatarPath + avatarUrl}
                        errorImg={defaultPlaceholder}
                        setLoaded={(status: boolean) => setLoaded(status)}
                        className={cn(classes.placeholderAvatar)}
                        id={id}
                    />
                </div>
                <div className={classes.nicknameContainer}>
                    <span className={cn(classes.playerNickname)}>{nickname}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={cn(classes.playerWrapper)}>
            <div className={classes.avatarContainer}>
                <UserStarsBorder starsCount={stars} className={classes.starsOverlay} starSize={9}/>
                <LazyImages
                    wrapperClassName={cn(
                        classes.playerAvatar,
                        { isLoaded: !isLoaded },
                        className
                    )}
                    placeholderImg={defaultPlaceholder}
                    src={endpoints.avatarPath + avatarUrl}
                    errorImg={defaultPlaceholder}
                    setLoaded={(status: boolean) => setLoaded(status)}
                    className={cn(classes.placeholderAvatar)}
                    id={id}
                />
            </div>
            <div className={classes.nicknameContainer}>
                <span className={cn(classes.playerNickname)}>{nickname}</span>
            </div>
        </div>
    );
};
